import React, { memo } from "react";
import { Shield } from "lucide-react";

interface ICOBadgeProps {
  size?: "small" | "medium" | "large";
  layout?: "vertical" | "horizontal";
  showText?: boolean;
  className?: string;
}

const ICOBadgeComponent = ({
  size = "medium",
  layout = "horizontal",
  showText = true,
  className = "",
}: ICOBadgeProps) => {
  const logoSizeClasses: Record<string, string> = {
    small: "h-8",
    medium: "h-12",
    large: "h-20",
  };

  const textSizeClasses: Record<string, string> = {
    small: "text-xs",
    medium: "text-sm",
    large: "text-base",
  };

  const isVertical = layout === "vertical";

  return (
    <a
      href="https://ico.org.uk/ESDWebPages/Entry/ZB963681"
      target="_blank"
      rel="noopener noreferrer"
      title="Tigola is registered with the Information Commissioner's Office (ICO) - UK Data Protection Authority"
      className={`inline-flex ${isVertical ? "flex-col" : "flex-row"} items-center gap-2 group transition-transform hover:scale-105 ${className}`}
    >
      {/* ICO Logo */}
      <div className="relative flex-shrink-0">
        <img
          src="https://cdn.builder.io/api/v1/image/assets%2Feeb669de10ca40b6919a1d6c2b388e0b%2F3c1af8d92a754a2da84f129a0f5e5db1?format=webp&width=800"
          alt="Information Commissioner's Office registered"
          className={`${logoSizeClasses[size]} w-auto object-contain`}
        />
      </div>

      {/* Text Content */}
      {showText && (
        <div className={`${isVertical ? "text-center" : "text-left"}`}>
          <p className={`font-semibold text-gray-900 ${textSizeClasses[size]}`}>
            ICO Registered
          </p>
          <p
            className={`text-gray-600 ${textSizeClasses[size]} ${isVertical ? "whitespace-normal" : "whitespace-nowrap"}`}
          >
            Data Protection
          </p>
        </div>
      )}

      {/* Hover effect indicator */}
      <Shield className="h-4 w-4 text-blue-600 opacity-0 group-hover:opacity-100 transition-opacity ml-1" />
    </a>
  );
};

export const ICOBadge = memo(ICOBadgeComponent);

export default ICOBadge;
